module.exports = __webpack_public_path__ + "fonts/700-italic-greek.c8cd7ab.woff2";